import { render } from "./UserAddress.vue?vue&type=template&id=eabde934&scoped=true"
import script from "./UserAddress.vue?vue&type=script&lang=js"
export * from "./UserAddress.vue?vue&type=script&lang=js"

import "./UserAddress.vue?vue&type=style&index=0&id=eabde934&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eabde934"]])

export default __exports__